import useAccount from "hooks/useAccount";
import React from "react";
import {
  FaChevronDown,
  FaEnvelope,
  FaQuestion,
  FaQuestionCircle,
  FaRegEnvelope,
  FaRegQuestionCircle,
  FaRegUser,
  FaUser,
  FaUserAlt,
} from "react-icons/fa";
const UserNavMenu = ({ isLoggedIn }) => {
  const { logout } = useAccount();

  const ProfileMenu = () => {
    return (
      <>
        <img
          src="/images/icons/nav/pink/profile-without-arrow.png"
          className="nav-icon"
        />
        <img src="/images/icons/nav/pink/arrow.png" className="nav-icon" />
      </>
    );
  };

  return (
    <div className="inline-block text-lg md:text-md ">
      <div className="flex items-start gap-3 pr-8 text-[var(--peachy-pink)]">
        {isLoggedIn && (
          <div className="mirum-user-menu relative flex flex-col items-start mt-0">
            <div className="flex items-center gap-2">
              <a href="/" className="hidden md:block">
                <div className="flex items-center">
                  <ProfileMenu />
                  {/* <FaRegUser /> */}
                  {/* <FaChevronDown style={{ fontSize: "0.5em" }} /> */}
                </div>
              </a>
              <div className="md:hidden flex items-center">
                <ProfileMenu />
                {/* <FaRegUser />
                <FaChevronDown style={{ fontSize: "0.5em" }} /> */}
              </div>
            </div>
            <div className="mirum-menu flex flex-col w-[150px] ml-[-125px] lowercase cursor-pointer text-black">
              <div className="p-2 md:hidden">
                <a href="//themirum.co.uk/faq" title="faq">
                  faq
                </a>
              </div>

              <div className="p-2 md:hidden">
                <a href="//themirum.co.uk/contact-us" title="contact us">
                  Contact Us
                </a>
              </div>
              {isLoggedIn && (
                <div onClick={logout} className="p-2">
                  Log out
                </div>
              )}
            </div>
          </div>
        )}
        <div className="hidden md:block">
          <a href="//themirum.co.uk/faq" title="faq" target="_blank">
            {/* <FaRegQuestionCircle /> */}
            <img src="/images/icons/nav/pink/faq.png" className="nav-icon" />
          </a>
        </div>
        <div className="hidden md:block">
          <a
            href="//themirum.co.uk/contact-us"
            title="contact us"
            target="_blank"
          >
            {/* <FaRegEnvelope /> */}
            <img
              src="/images/icons/nav/pink/envelope.png"
              className="nav-icon"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default UserNavMenu;
